export default "__VITE_ASSET__BzlKFTTX__"